/**
 * @generated SignedSource<<ed7928395d1509dfdf5ba52345df3af8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StatusColumnHeaderOld_view$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BoardHeaderDropdown_view">;
  readonly " $fragmentType": "StatusColumnHeaderOld_view";
};
export type StatusColumnHeaderOld_view$key = {
  readonly " $data"?: StatusColumnHeaderOld_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"StatusColumnHeaderOld_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "StatusColumnHeaderOld_view",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardHeaderDropdown_view"
    }
  ],
  "type": "JiraBoardView"
};

(node as any).hash = "632182e00feaf5f57ba50ce9c7495674";

export default node;
